module.exports = __webpack_public_path__ + "static/media/wonder_ends_diffuse.41ddd1db.png";